import { render } from "./NormActions.vue?vue&type=template&id=02ae0254&scoped=true"
import script from "./NormActions.vue?vue&type=script&lang=js"
export * from "./NormActions.vue?vue&type=script&lang=js"

import "./NormActions.vue?vue&type=style&index=0&id=02ae0254&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ae0254"]])

export default __exports__